import { render } from "./ZircAndVeneers.vue?vue&type=template&id=23c2521a"
import script from "./ZircAndVeneers.vue?vue&type=script&lang=js"
export * from "./ZircAndVeneers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__